import { IEnumeration } from 'utility-js-enumeration';
import * as _4 from 'lodash4';
import { IContentTabEnumConfig, IContentTabEnumItem } from '../main';

export class ContentTabViewComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-content-tabs/src/content_tab_view/content_tab_view.html';
  public controller: any = ContentTabViewController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    tabEnum: '<'
  };
}

export class ContentTabViewController {
  private tabEnum: IContentTabEnumConfig;
  private tabs: IContentTabEnumItem[];
  private activeTabState: string;

  constructor(private $state: ng.ui.IStateService) {}

  $onInit() {
    this.tabs = _4.sortBy(_4.toArray(this.tabEnum.__ordinals__), 'tabOrder');
    const hasActiveTab = _4.find(this.tabs, (i: any) => i.isActive());
    if (!hasActiveTab) {
      const firstTab: IContentTabEnumItem = _4.first(this.tabs);
      this.activeTabState = firstTab.state;
      this.$state.go(firstTab.state);
    } else {
      this.activeTabState = hasActiveTab.state;
    }
  }

  goToTab($event: JQueryEventObject): void {
    const newState: string = _4.get($event.target, 'value');
    this.$state.go(newState);
    this.activeTabState = newState;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-content-tabs/src/content_tab_view/content_tab_view.ts